import React, { useState } from 'react';
import Styles from './Boleto25Banner.css';
import Container from '@/components/atoms/Container';
import WhiteButton from '@/components/atoms/WhiteButton';
import ContainerHome24 from '@/components/atoms/ContainerHome24';
function Boleto25Banner() {
  const [width, setWidth] = useState(typeof window === 'undefined' ? 0 : window.window.innerWidth);

  if (typeof window === 'undefined') {
    console.log('');
  } else {
    window.addEventListener('resize', function () {
      setWidth(window.window.innerWidth);
    });
  }
  return (
    <>
      <section id="boleto-banner" className="stacked-banner">
        <div className="bg-image-wrapper">
          {typeof window === 'undefined' ? (
            <></>
          ) : (
            <>
              {width <= 992 && (
                <picture>
                  <source type="image/webp" srcSet="assets/boleto25/banner/bg-banner-mobi.webp" />
                  <source type="image/png" srcSet="assets/boleto25/banner/bg-banner-mobi.png" />
                  <img
                    src="assets/boleto25/banner/bg-banner-mobi.png"
                    alt="Três mulheres vendo no celular sobre como gerar boleto seguro no Santander."
                  />
                </picture>
              )}
              {width > 992 && (
                <picture>
                  <source type="image/webp" srcSet="assets/boleto25/banner/bg-banner-desk.webp" />
                  <source type="image/png" srcSet="assets/boleto25/banner/bg-banner-desk.png" />
                  <img
                    src="assets/boleto25/banner/bg-banner-desk.png"
                    alt="Três mulheres vendo no celular sobre como gerar boleto seguro no Santander."
                  />
                </picture>
              )}
            </>
          )}
        </div>
        {/* <div className="fade-banner" /> */}
        <div className="fade-banner-gradiente" />
        <div className="santander-symbol" />

        <div className="text-box-position">
          <ContainerHome24>
            <div className="text-box">
              <h1 className="main-text">Boletos</h1>
              <p className="alt-text">
                Conheça os serviços online oferecidos pela Santander Financiamentos.
                <br />
                <br />
                Você consegue a 2ª via do boleto de forma rápida e fácil!
              </p>
              <WhiteButton
                href="https://www.santanderfinanciamentos.com.br/spa-mktfinweb/#/login?int_source=portalSF"
                target="_blank"
                rel="noopener"
                className="btn-simulate"
              >
                Gerar boletos
              </WhiteButton>
            </div>
          </ContainerHome24>
        </div>
      </section>

      <style jsx>{Styles}</style>
    </>
  );
}

export default Boleto25Banner;
